import { useAutoTranslate } from "@/hooks/useAutoTranslate";

/**
 * Drop this component into any page layout to enable
 * automatic DOM-level translation of all visible text.
 */
const AutoTranslate = () => {
  useAutoTranslate();
  return null;
};

export default AutoTranslate;
